@if (strategies) {
  @if (strategies.length <= strategiesPerPage) {
    <div class="swiperless-view">
      @for (modelStrategy of strategies; track modelStrategy.modelStrategyId) {
        <libero-model-strategy-card
          [modelStrategy]="modelStrategy"
        ></libero-model-strategy-card>
      }
    </div>
  }
  <div class="swiper-container" [ngClass]="{ 'swiper-container--phone-only': strategies.length <= strategiesPerPage }">
    <div class="desktop-swiper-prev swiper-arrow swiper-arrow--left" #swiperPrevArrow>
      <svg-icon src="assets/icons/arrow.svg" [svgStyle]="{ 'width.px':18 }"></svg-icon>
    </div>
    <div>
      <swiper
        [slidesPerView]="slidesPerView(strategies.length)"
        [pagination]="{
          clickable: true
        }"
        [navigation]="{
          enabled: true,
          nextEl: swiperNextArrow,
          prevEl: swiperPrevArrow,
          disabledClass: 'swiper-arrow--disabled'
        }"
        [slidesOffsetBefore]="18"
        [slidesOffsetAfter]="18"
        [spaceBetween]="15"
        [freeMode]="true"
        >
        @for (modelStrategy of strategies; track modelStrategy.modelStrategyId) {
          <ng-template swiperSlide>
            <libero-model-strategy-card
              [modelStrategy]="modelStrategy"
            ></libero-model-strategy-card>
          </ng-template>
        }
      </swiper>
    </div>
    <div class="desktop-swiper-next swiper-arrow swiper-arrow--right" #swiperNextArrow>
      <svg-icon src="assets/icons/arrow.svg" [svgStyle]="{ 'width.px':18, 'transform': 'rotate(180deg)' }"></svg-icon>
    </div>
  </div>
}